// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__2BC1o","footer":"ModalUpdate_footer__3edUL"};